import { DashboardModule } from '@domain-group/suit-theme'

import { UseAgencyMarketingPayload } from '@hooks/useAgencyMarketing'

import TagListItem from './TagListItem'

interface AllTagsProps {
  agencyMarketingPayload: UseAgencyMarketingPayload,
}

const AllTags = (props: AllTagsProps) => {
  const { agencyMarketingPayload } = props

  const {
    callbacks,
    tagsPayload: {
      callbacks: { loadMore },
      canLoadMore,
      filteredTags,
      filteredTagsCount,
      hasFilteredTags,
      loading,
    },
  } = agencyMarketingPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      boxProps={{ marginBottom: 'large' }}
      title="All Tags"
    >
      {!hasFilteredTags && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Tags Present.
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please Contact Support
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {hasFilteredTags && (
        // @ts-expect-error TS2322
        <DashboardModule.ScrollableSection flexDirection="column" maxHeight={600}>
          {filteredTags.map(tag => <TagListItem callbacks={callbacks} tag={tag} />)}
        </DashboardModule.ScrollableSection>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredTagsCount}
        loading={loading}
        showBorderTop={false}
      />
    </DashboardModule>
  )
}

export default AllTags
